import { tryParseJson } from "./try-parse-json";

type TipTapNode = {
  type?: string;
  text?: string;
  content?: TipTapNode[];
};

export function extractTipTapText(node: TipTapNode | null | undefined, isRoot = true): string {
  if (!node) return "";
  if (node.type === "text" && node.text) return node.text;
  if (!node.content) return "";
  const text = node.content.map((child) => extractTipTapText(child, false)).join(node.type === "doc" ? "\n" : "");
  return isRoot ? text.trim() : text;
}

export function extractPlainTextFromTipTap(value: string | null | undefined): string | null {
  if (!value) return null;
  const parsed = tryParseJson(value);
  if (parsed && typeof parsed === "object") {
    if ("json" in parsed) {
      const doc = parsed as { text?: string; json: TipTapNode };
      return doc.text || extractTipTapText(doc.json) || null;
    }
    if ("type" in parsed && (parsed as TipTapNode).type === "doc") {
      return extractTipTapText(parsed as TipTapNode) || null;
    }
  }
  return value;
}

export interface DescriptionContent {
  displayText: string | null;
  rawValue: string;
}

export function analyzeDescription(desc: string | null | undefined): DescriptionContent | null {
  if (!desc) return null;
  const parsed = tryParseJson(desc);
  if (parsed && typeof parsed === "object") {
    if ("json" in parsed) {
      const doc = parsed as { text?: string; json: TipTapNode };
      return { displayText: doc.text || extractTipTapText(doc.json) || null, rawValue: desc };
    }
    if ("type" in parsed && (parsed as TipTapNode).type === "doc") {
      const text = extractTipTapText(parsed as TipTapNode);
      return { displayText: text || null, rawValue: JSON.stringify({ text, json: parsed }) };
    }
  }
  return { displayText: desc, rawValue: desc };
}
